<script>
import { mapState, mapActions } from 'vuex'
import Tree from 'liquor-tree'

export default {
  name: 'Sidebar',
  components: {
    Tree
  },
  data () {
    return {
      treeData: [
        {
          text: 'Documentos',
          state: { expanded: true },
          children: [
            { text: 'NFe', link: 'nfes', state: { selected: this.$route.name === 'nfes' } },
            { text: 'NFCe', link: 'nfces', state: { selected: this.$route.name === 'nfces' } },
            { text: 'CFe', link: 'cfes', state: { selected: this.$route.name === 'cfes' } },
            { text: 'CTe', link: 'ctes', state: { selected: this.$route.name === 'ctes' } },
            { text: 'NFSe', link: 'nfses', state: { selected: this.$route.name === 'nfses' } }
          ]
        },
        {
          text: 'Sistemas',
          state: { expanded: true, visible: false },
          children: [
            { text: 'Usuários', link: 'users', state: { selected: this.$route.name === 'users' } },
            { text: 'Contadores', link: 'contadores', state: { selected: this.$route.name === 'contadores' } },
            { text: 'Alterar Senha', link: 'config', state: { selected: this.$route.name === 'config' } },
            { text: 'Painel', link: 'config-emitente', state: { selected: this.$route.name === 'config-emitente' } }
          ]
        }
        
      ]
    }
  },
  created () {
    this.setVisibilityMenus()
  },
  methods: {
    onNodeSelected (node) {
      for (let i = 0; i < this.treeData.length; i++) {
          if (this.treeData[i].children === undefined) {
            if (this.treeData[i].text === node.text) {
              this.ToogleMenu(false)
              this.$router.push({ name: this.treeData[i].link })
            }
          } else {
            for (let j = 0; j < this.treeData[i].children.length; j++) {
              if (this.treeData[i].children[j].text === node.text) {
                this.ToogleMenu(false)
                this.$router.push({ name: this.treeData[i].children[j].link })
              }
            }
          }
      }
    },
    setVisibilityMenus () {
      let permissionAccess = (this.user.user.tipo === 'D' || this.user.user.tipo === 'A')
      this.treeData[1].state.visible = true

      this.treeData[1].children[0].state.visible = permissionAccess
      this.treeData[1].children[1].state.visible = permissionAccess
      this.treeData[1].children[3].state.visible = permissionAccess
    },
    ...mapActions('menu', ['ToogleMenu']),
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('menu', ['showSidebar'])
  }  
}
</script>

<template>
  <transition name="fade">
    <div class="bg-sidebar fixed" @click="ToogleMenu(false)" v-if="showSidebar">
      <div class="sidebar sidebar-fluid navbar-nav sidebar-fixed bg-white fixed">
        <Tree
        :data='treeData'
        @node:selected="onNodeSelected"
        >
        </Tree>
      </div>
    </div>
  </transition>
</template>

<style>
  .fixed { position: fixed; z-index: 999;}
  .hide-bar { display: none !important;}
  .sidebar-fluid{width: 278px !important; box-shadow: 1px 1px 3px 2px #aaa}
  .tree-node .selected > .tree-content {background-color: rgb(235, 235, 235) !important; color: #09316f;}
  .bg-sidebar{margin: 0; width: 500%; height: 100%; background: rgba(0, 0, 0, .3);}
  .fade-enter-active, .fade-leave-active {transition: opacity .5s;}
  .fade-enter, .fade-leave-to {opacity: 0;}
</style>
